export default __webpack_public_path__ + "static/media/ebook-box-image-05.a3d2c54a.png";